import { useNavigate } from 'react-router-dom'
import { Icon } from '@carrent/ui'

/** Гаджет: Тикеты поддержки. */

export function SupportTicketsWidget({ data }) {
  const navigate = useNavigate()

  if (!data.counts.active) {
    return <p className="widget-empty">Открытых обращений нет</p>
  }

  return (
    <div className="tickets-widget">
      {data.avg_response_h != null ? (
        <p className="tickets-widget__response">
          Первый ответ в среднем через <b>{data.avg_response_h} ч</b>
          <span className="text-muted"> · по обращениям за 30 дней</span>
        </p>
      ) : data.response_sample > 0 ? (
        <p className="tickets-widget__response tickets-widget__response--warn">
          За 30 дней ни на одно обращение не ответили
        </p>
      ) : null}

      <ul className="tickets-widget__counts">
        {data.by_priority.map((p) => (
          <li key={p.key} className={`tickets-widget__count tickets-widget__count--${p.key}`}>
            <span className="tickets-widget__count-value">{p.value}</span>
            <span className="tickets-widget__count-label">{p.label}</span>
          </li>
        ))}
      </ul>

      <ul className="widget-list">
        {data.items.map((t) => (
          <li key={t.id}>
            <button
              type="button"
              className="incidents__row"
              onClick={() => navigate(`/admin/tickets/${t.id}`)}
            >
              <span
                className={`incidents__icon incidents__icon--${
                  t.priority === 'urgent' ? 'danger' : 'warning'
                }`}
              >
                <Icon name="chat" size={16} />
              </span>
              <span className="incidents__main">
                <span className="incidents__title">{t.subject}</span>
                <span className="incidents__meta">{t.status}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
